import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { gsap } from 'gsap';
import { onMounted, reactive, toRefs, watch } from 'vue';


const __default__ = {
  name: 'AppNumber',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    input: null,
    fixed: null
  },
  setup(__props: any) {

const props = __props as {
  input: number;
  fixed: number;
};



const tweened = reactive({
  number: 0
});
const { input } = toRefs(props);

const tween = (newValue: number): void => {
  gsap.to(tweened, {
    duration: 0.4,
    number: newValue,
    ease: 'sine',
  });
};

watch(input, (newInput) => {
  tween(newInput);
});

onMounted(() => {
  tween(input.value)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, _toDisplayString(tweened.number.toFixed(__props.fixed)), 1 /* TEXT */))
}
}

})